import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-headcount-report',
  templateUrl: './headcount-report.component.html',
  styleUrls: ['./headcount-report.component.scss']
})
export class HeadcountReportComponent implements OnInit {

  constructor() {
    
  }

  ngOnInit(): void {
  }

}
